import React, { useState, useCallback, useContext } from 'react';
import clsx from 'clsx';
import { PropTypes } from 'prop-types';

import { ChipsShadow } from 'components/ShadowBox';
import { ChipGroup } from 'components';
import { UserTeam } from 'components/SvgIcon';

import {
  actionTypes,
  UserDrawerContext,
} from '../../../../UserDrawerContent/UserDrawerContext';

const NoTeams = () => {
  return (
    <div
      className={clsx(
        'Caption-Emphasis',
        'm-user-edit-drawer-section__team-chips__no-teams',
      )}
    >
      There are currently no teams assigned to this user.
    </div>
  );
};

export const TeamChips = ({ primaryTeam, showPrimaryTeam }) => {
  const {
    dispatchUserDrawer,
    userDrawerState: { assignedTeams = [], isTeamsLoading },
  } = useContext(UserDrawerContext);
  const [showOpened, setShowOpened] = useState(false);
  const handleShowOpened = useCallback(() => {
    setShowOpened((e) => !e);
  });

  const handleRemove = (deletedTeam) => {
    dispatchUserDrawer({
      type: actionTypes.SET_ASSIGNED_TEAMS,
      assignedTeams: assignedTeams.filter((team) => team.id !== deletedTeam),
    });
  };

  const chipList = assignedTeams
    .filter((team) => (showPrimaryTeam ? team.id !== primaryTeam : team.id))
    .map((team) => {
      return {
        key: team.id,
        label: `${team.name}`,
        onDelete: handleRemove,
      };
    });

  const ShowChips = () => {
    if (isTeamsLoading) {
      return <ChipsShadow />;
    }

    if (assignedTeams.length === 0) {
      return <NoTeams />;
    }

    return (
      <ChipGroup
        chipList={chipList}
        open={showOpened}
        showClick={handleShowOpened}
        className="editUser"
        labelClassName="Body-Emphasis"
        chipIcon={
          <span
            className="m-user-edit-drawer-section__chips__icon-teams"
            data-testid="PlatformAdminUI-UsersLink-TeamChips-Icon"
          >
            <UserTeam />
          </span>
        }
        chipClassName="editUser"
        maxHeight={75}
      />
    );
  };

  return (
    <div
      className="m-user-edit-drawer-section__chips"
      data-testid="PlatformAdminUI-UsersLink-TeamChips-Section"
    >
      <ShowChips />
    </div>
  );
};

TeamChips.propTypes = {
  primaryTeam: PropTypes.number.isRequired,
  showPrimaryTeam: PropTypes.bool.isRequired,
};
